import React from 'react'

const ParentComponent = props => (
  <div>
    <div id="children-pane">
      {props.children}
    </div>
       <p><a style={{cursor: "pointer"}} onClick={props.addChild}>Add Another Guest</a></p>
  </div>
);

export default class MultiFormWrapper extends React.Component {
	constructor(props) {
        super(props);
        this.state = {
            value: '',
            numChildren: this.props.numberOfFormsToRender
        };

    }
    componentWillReceiveProps(nextProps) {
	     this.setState({
             numChildren: nextProps.numberOfFormsToRender
         })
    }


 render () {
    return (

         <ParentComponent key="parentcomponent" addChild={this.props.onAddChild}>
             <h4> Property: {this.props.propertyName}</h4>
             {this.props.children}
      </ParentComponent>

    )
  }

}



// WEBPACK FOOTER //
// ./src/components/MultiFormWrapper.js